// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import router from './router'
import store from './store'
import Components from './components'
import {Post, Get} from './libs/request'
import {Toast,Search,TreeSelect, Rate} from 'vant'
import utils from './libs/utils'
import dataResource from './const'
// import 'vant/lib/index.css'
import VueOccupy from 'vue-occupy'
import ws from '@/libs/websocket'
import API from '@/libs/request/api'

Vue.use(VueOccupy)

Vue.config.productionTip = false

Vue.use(Components)
Vue.use(Search).use(TreeSelect).use(Rate)
// Vue.use(Sidebar)
Vue.prototype.$api = API
Vue.prototype.$post = Post
Vue.prototype.$get = Get
Vue.prototype.$dataResource = dataResource
Toast.setDefaultOptions({
  duration: 1500
})

Vue.prototype.$utils = utils
Vue.config.ignoredElements = ['wx-open-launch-weapp']

let env = process.env.NODE_ENV
if (env === 'production') {
  // 屏蔽所有log
  console.log = () => {
  }
  console.info = () => {
  }
  console.warn = () => {
  }
}

const initBaidu = () => {
  var _hmt = [];
  (function () {
    var hm = document.createElement('script')
    hm.src = 'https://hm.baidu.com/hm.js?48bee6659d6ca17daca79b4991b47dca'
    var s = document.getElementsByTagName('script')[0]
    s.parentNode.insertBefore(hm, s)
  })()

  router.beforeEach((to, from, next) => {
    var rou = ''
    if (window.location.href.indexOf('/?/') > -1) {
      console.log(1321321, '/?/')
      var url = window.location.href.split('/?/')[1]
      if (url.indexOf('#/') > -1) {
        console.log("url.split('#/')[0]", url.split('#/')[0])
        rou = '#/'+url.split('#/')[0]
        window.location.href = window.origin + location.pathname + rou
        return
      }
    }
    if (_hmt) {
      if (to.path) {
        utils.baiDuUtil.trackPageView(to.path)
      }
    }
    next()
  })
}

initBaidu()

/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  store,
  components: {App},
  created () {
    if (
      this.$store.state &&
      this.$store.state.User &&
      this.$store.state.User.userInfo
    ) {
      let userInfo = this.$store.state.User.userInfo
      ws.init(API.API_WEB_SOCKET + '/' + userInfo.id)
    }

    // if (localStorage && localStorage.userInfo) {
    //   store.commit('LoginModule/setUserInfo', localStorage.userInfo)
    // }
  },
  template: '<App/>'
})



// WEBPACK FOOTER //
// ./src/main.js